import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconUndoStyle0 = cosmosIconCss;

const CosmosIconUndo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUndo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '81d8d19fac2a11fe3a6ec7a45268eb663ffd393b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'aecc9aafd2e168bd727189e4fad150ce688c6817', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '97b40a84962924701f97ab455af45d00f948f1d4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.634 7.472H8.006V5.2a.5.5 0 0 0-.853-.354L4.12 7.87a.5.5 0 0 0 0 .706l3.032 3.052a.5.5 0 0 0 .854-.352v-2.3h4.628a3.6 3.6 0 0 1 3.662 3.358 3.323 3.323 0 0 1-.939 2.473 3.687 3.687 0 0 1-1.926 1.015.51.51 0 0 0-.425.493v.532a.509.509 0 0 0 .587.5 5 5 0 0 0 2.841-1.493 4.852 4.852 0 0 0 1.362-3.565 5.11 5.11 0 0 0-5.162-4.817Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconUndoStyle0; }
}, [1, "cosmos-icon-undo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-undo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-undo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUndo$1);
            }
            break;
    } });
}

const CosmosIconUndo = CosmosIconUndo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUndo, defineCustomElement };
